import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { WcGridModule } from '../../components/wc-grid/wc-grid.module';
import { WcGridComponent } from '../../components/wc-grid/wc-grid.component';
import { ModelsTableDetailComponent } from './models-table-detail.component';
import { ForeignKeyCreateDialogComponent } from './foreign-key-create-dialog.component';

@Component({
  selector: 'app-models-schema-detail',
  standalone: true,
  templateUrl: './models-schema-detail.component.html',
  styleUrls: ['./models-schema-detail.component.css'],
  imports: [CommonModule, MatTabsModule, MatButtonModule, MatDialogModule, WcGridModule, ModelsTableDetailComponent],
})
export class ModelsSchemaDetailComponent implements OnChanges {
  @Input() schemaId!: string;
  @Input() schemaName!: string;
  @Output() back = new EventEmitter<void>();

  @ViewChild('fkGrid') fkGrid?: WcGridComponent;

  gridContext: Record<string, any> = {};
  selectedTable: { id: string; name: string } | null = null;

  readonly tableRowActions = [{ id: 'openFields', label: 'Manage Fields' }];

  constructor(private dialog: MatDialog) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['schemaId'] && this.schemaId) {
      this.gridContext = { schemaId: this.schemaId };
    }
  }

  openTable(event: { id: string; row: Record<string, any> }): void {
    if (event.id !== 'openFields') return;
    this.selectedTable = { id: event.row['Id'], name: event.row['DisplayName'] };
  }

  closeTable(): void {
    this.selectedTable = null;
  }

  openForeignKeyDialog(): void {
    const ref = this.dialog.open(ForeignKeyCreateDialogComponent, {
      data: { schemaId: this.schemaId },
      panelClass: 'fk-dialog-panel',
      width: '760px',
      maxWidth: '95vw',
      height: '640px',
      maxHeight: '90vh',
    });

    ref.afterClosed().subscribe((created: boolean) => {
      if (created) this.fkGrid?.reload(1);
    });
  }
}
